module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/bass-guitars-ff83b264ca64d9180e5e6cff963d93eb.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/bass-guitars.png
// module id = OsT0
// module chunks = 9 11 12